const translations = {
  "en": {
    "Analyze Image": "Analyze Image",
    "Analyze PDF": "Analyze PDF",
    "Confirm": "Confirm",
    "File too large (image ≤ 10MB)": "File too large (image ≤ 10MB)",
    "File too large (PDF ≤ 20MB)": "File too large (PDF ≤ 20MB)",
    "Format not supported. Images: JPG, JPEG, PNG, HEIC, WebP.": "Format not supported. Images: JPG, JPEG, PNG, HEIC, WebP.",
    "Format not supported. Only PDF files are allowed.": "Format not supported. Only PDF files are allowed.",
    "Some files could not be uploaded because you can only upload 5 attachments at a time": "Some files could not be uploaded because you can only upload 5 attachments at a time",
    "Upload Image": "Upload Image",
    "Upload images to verify your assets (Maximum 5 images).": "Upload images to verify your assets (Maximum 5 images).",
    "Upload PDF": "Upload PDF",
    "Upload PDF files to verify your assets (Maximum 5 files, 20MB each).": "Upload PDF files to verify your assets (Maximum 5 files, 20MB each).",
    "You can only upload 5 files at a time": "You can only upload 5 files at a time",
    "You can only upload 5 images at a time": "You can only upload 5 images at a time"
  },
  "zh-tw": {
    "Analyze Image": "分析圖片",
    "Analyze PDF": "分析 PDF",
    "Confirm": "確認",
    "File too large (image ≤ 10MB)": "檔案過大（圖片 ≤ 10MB）",
    "File too large (PDF ≤ 20MB)": "檔案過大（PDF ≤ 20MB）",
    "Format not supported. Images: JPG, JPEG, PNG, HEIC, WebP.": "格式不受支援。圖片：JPG、JPEG、PNG、HEIC、WebP。",
    "Format not supported. Only PDF files are allowed.": "格式不受支援。僅允許 PDF 檔案。",
    "Some files could not be uploaded because you can only upload 5 attachments at a time": "某些檔案無法上傳，因為你每次只能上傳 5 個附件。",
    "Upload Image": "上傳圖片",
    "Upload images to verify your assets (Maximum 5 images).": "上傳圖片以驗證你的資產（最多 5 張圖片）。",
    "Upload PDF": "上傳 PDF",
    "Upload PDF files to verify your assets (Maximum 5 files, 20MB each).": "上傳 PDF 檔案以驗證你的資產（最多 5 個檔案，每個 20MB）。",
    "You can only upload 5 files at a time": "一次只能上傳 5 個檔案",
    "You can only upload 5 images at a time": "一次只能上傳 5 張圖片"
  }
};

export default translations;
